<app-nav></app-nav>
<section class="payment-status">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
    </div>
    <div class="seperator"></div>
    <div class="col download-document">
      <h4 class="text-center mt-3 thanks-title">Thank you for payment</h4>
    </div>
    <div class="col download-document">
      <h6 class="text-center mt-3 thanks-title">You will get all your policy related documents via mail in next 3 working days.</h6>
    </div>

    <div class="col footer-strip text-center">
      <img
      src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
      class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
